type VeriCreatorLogoProps = {
  readonly className?: string;
  readonly onDark?: boolean;
  readonly title?: string;
};

/**
 * Canonical VeriCreator symbol.
 *
 * This is the same geometry used by the institutional page: the organic
 * left-hand stroke represents the creator's gesture, the precise gold stroke
 * represents the protocol, and both meet at a single point of reference.
 */
export function VeriCreatorLogo({ className, onDark = false, title }: VeriCreatorLogoProps) {
  const neutral = onDark ? "var(--paper)" : "var(--ink)";

  return (
    <svg
      aria-hidden={title ? undefined : true}
      aria-label={title}
      className={className}
      fill="none"
      role={title ? "img" : undefined}
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
    >
      {title ? <title>{title}</title> : null}
      <path d="M44 50C30 95 55 120 100 156" stroke={neutral} strokeLinecap="round" strokeWidth="10" />
      <path d="M156 50L100 156" stroke="var(--seal)" strokeLinecap="round" strokeWidth="10" />
      <circle cx="100" cy="156" fill="var(--seal)" r="7" />
    </svg>
  );
}
